import Vue from 'vue'
import * as validators from '@/utils/validators'
import SortableList from 'components/SortableList'
import '@/directives/dragAndDrop'
import { $ui } from '@/utils/ui'
import LwfSubSelect from 'components/core/LwfSubSelect'

/**
 * Rend disponible tous les validators dans le templates
 * Exemple :
 *   <Field :rules="[$validators.required]"/>
 */
Vue.prototype.$validators = validators

Vue.prototype.$ui = $ui
Vue.prototype.$APP = process.env.APP

Vue.component(SortableList.name, SortableList)
Vue.component(LwfSubSelect.name, LwfSubSelect)

window.$validators = validators // TODO ts file ?
